export default "__VITE_ASSET__Cvp84Fjl__"